module.exports = __webpack_public_path__ + "static/TT1332_TW-MARK-D04-clean-61b49df2ba8633223b5232243e89755e.png";